import React from "react";
import MiniCalendarWidget from "../../sales/components/MiniCalendarWidget";
import WeatherWidget from "../../sales/components/WeatherWidget";
import ScheduleWidget from "../../sales/components/ScheduleWidget";
import VenuesWidget from "../../sales/components/VenuesWidget";
import SocialMediaWidget from "../../sales/components/SocialMediaWidget";
import MemoryBooksWidget from "../../sales/components/MemoryBookWidget";
import ServiceQuoteForm from "../../proposal/service-quote-form/ServiceQuoteForm";

export type DashboardKey = "sales" | "operations" | "tv";

export type DashboardWidgetConfig = {
  id: string;
  title: string;
  description: string;
  dashboards: DashboardKey[];
  defaultSlot: WidgetSlot;
  render: (props: DashboardWidgetRenderProps) => React.ReactNode;
};

export type DashboardWidgetRenderProps = {
  selectedDate?: Date;
  onDateSelect?: (date: Date) => void;
  crewMemberId?: number | null;
};

export type ActiveDashboardWidget = {
  id: string;
  visible: boolean;
  slot: WidgetSlot;
  
};
export type WidgetSlot =
  | { type: "sidebar_top_left" }
  | { type: "sidebar_top_right" }
  | { type: "sidebar_bottom" }
  | { type: "main_primary" }
  | { type: "main_grid"; size: { xs: number; md: number } };

export const ALL_DASHBOARD_WIDGETS: DashboardWidgetConfig[] = [
  {
    id: "mini_calendar",
    title: "Mini Calendar",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "sidebar_top_left" },
    render: (props) => (
      <MiniCalendarWidget
        selectedDate={props.selectedDate ?? new Date()}
        onDateSelect={props.onDateSelect ?? (() => {})}
      />
    ),
  },
  {
    id: "weather",
    title: "Weather",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "sidebar_top_right" },
    render: () => <WeatherWidget />,
  },
  {
    id: "schedule",
    title: "Schedule",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "sidebar_bottom" },
    render: (props) => (
      <ScheduleWidget
        selectedDate={props.selectedDate ?? new Date() }
        crewMemberId={props.crewMemberId ?? 0}
      />
    ),
  },
  {
    id: "service_quote_form",
    title: "Service Quote Form",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "main_primary" },
    render: () => <ServiceQuoteForm />,
  },
  {
    id: "venues",
    title: "Venues Needing Attention",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "main_grid", size: { xs: 12, md: 4 } },
    render: () => <VenuesWidget />,
  },
  {
    id: "social_media",
    title: "Social Media To Do",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "main_grid", size: { xs: 12, md: 4 } },
    render: () => <SocialMediaWidget />,
  },
  {
    id: "memory_books",
    title: "Memory Books",
    dashboards: ["sales", "operations"],
    description: "Shows a small monthly calendar",
    defaultSlot: { type: "main_grid", size: { xs: 12, md: 4 } },
    render: () => <MemoryBooksWidget />,
  },
];
export const getDashboardStorageKey = (dashboardKey: DashboardKey) =>
  `${dashboardKey}DashboardWidgets`;

export const getDefaultWidgetsForDashboard = (
  dashboardKey: DashboardKey,
): ActiveDashboardWidget[] => {
  return ALL_DASHBOARD_WIDGETS.filter((widget) =>
    widget.dashboards.includes(dashboardKey),
  ).map((widget) => ({
    id: widget.id,
    visible: true,
    slot: widget.defaultSlot,
    size: widget.defaultSlot.type === "main_grid" ? widget.defaultSlot.size : { xs: 12, md: 12 },
  }));
};
